import { FC } from 'react';
import { TableData } from '@/components/Table/types';
import { Schedule } from '@/components/Schedule/types';
import { DataTableValue } from 'primereact/datatable';

import { Table } from '@/components';
import { getTableColumns, tableFilters } from './tableColumns';

export interface Viaje {
  viaje: string;
  eta: string;
  apertura: string;
  cierre: string;
  servicio: string;
}

type TripTableProps = {
  data: Schedule[] | undefined;
  isLoading: boolean;
  handleSelectionChange?: (e: { value: unknown }) => void;
  selectedItems?: unknown[];
};

const TripTable: FC<TripTableProps> = ({
  data,
  isLoading,
  selectedItems,
  handleSelectionChange,
}) => {
  const tableColumns = getTableColumns();

  return (
    <Table
      columns={tableColumns}
      data={data as unknown as TableData}
      isLoading={isLoading}
      paginator
      filterDisplay="menu"
      onSelectionChange={handleSelectionChange}
      selectedItems={selectedItems as DataTableValue[]}
      selectionId="codigo"
      filters={tableFilters}
    />
  );
};

export default TripTable;
